import { type Nullable } from "@/utils/types";

import React, { type FunctionComponent } from "react";

import * as styles from "./CategorySelectButton.style";

interface IProps
{
  readonly id: Nullable<string>;
  readonly isActive: boolean;
  readonly setSelectedCategoryId: (id: string | undefined) => void;
  readonly title: Nullable<string>;
}

const CategorySelectButton: FunctionComponent<IProps> = ({
  id,
  isActive,
  setSelectedCategoryId,
  title
}) => (
  <button
    key={id}
    type="button"
    css={[styles.button, isActive && styles.active]}
    onClick={() => setSelectedCategoryId(id || undefined)}>
    {title}
  </button>
);

export default CategorySelectButton;
